import { createFileRoute } from "@tanstack/react-router"
import { NamePage } from "@/pages/onboarding"

export const Route = createFileRoute("/onboarding/name")({
	component: NamePage,
})
